import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UrlBuilder } from '../../../core';
import { findSelectedStudy, findStudySiteIdentities } from '../../../shared/route-helpers';
import { SponsorEQueriesCountersStorage } from '../sponsor-e-queries-counters-storage';
import { take, filter } from 'rxjs/operators';
import { find } from 'lodash';

@Component({
     template: require('../../redirection.component.html'),
     styles: [require('../../redirection.component.scss')],
     changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SponsorEQueryRedirectionComponent implements OnInit, OnDestroy {
    public isActive = new BehaviorSubject(true);
    private subscription: Subscription;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly urlBuilder: UrlBuilder,
        private readonly sponsorEQueriesCountersStorage: SponsorEQueriesCountersStorage,
    ) { }

    public async ngOnInit() {
        const selectedStudy = findSelectedStudy(this.route.snapshot);
        const siteIdentities = findStudySiteIdentities(this.route.snapshot);

        if (!selectedStudy || !siteIdentities || siteIdentities.length === 0) {
            this.isActive.next(false);
            return;
        }

        this.subscription = this.sponsorEQueriesCountersStorage.counters.pipe(
            filter(c => !!c),
            take(1),
        ).subscribe(counters => {
            const firstCounter = find(counters, c => c.protocolId === selectedStudy.protocolId && c.totalUnresolved.size > 0);
            const selectedSite = firstCounter
                ? find(siteIdentities, s => s.siteId === firstCounter.key)
                : siteIdentities[0];

            this.urlBuilder
                .esa()
                .sponsor()
                .study(selectedStudy)
                .eQueries(selectedSite.siteId)
                .awaitingResponse()
                .navigate({ navigationExtras: { replaceUrl: true } });
        });
    }

    public ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
